module.exports = __webpack_public_path__ + "img/8.4d86dc12.jpg";